import { ref } from 'vue'

type ViewMode = 'grid' | 'table'
export type TableStyle = 'refined' | 'fusion' | 'modern'

const stored = localStorage.getItem('dashboard-view-mode')
const _viewMode = ref<ViewMode>(stored === 'table' ? 'table' : 'grid')
const _showCreateSheet = ref(false)

export function useDashboardViewMode() {
  const toggleViewMode = () => {
    _viewMode.value = _viewMode.value === 'grid' ? 'table' : 'grid'
    localStorage.setItem('dashboard-view-mode', _viewMode.value)
  }

  return {
    viewMode: _viewMode,
    toggleViewMode,
    showCreateSheet: _showCreateSheet,
  }
}
